module.exports = __webpack_public_path__ + "static/img/abimbola.3c41f43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/abimbola.png
// module id = ocI+
// module chunks = 0